export const MATERIAL_RETURNED = 'Material returned';
export const MATERIAL_DISPOSED = 'Material disposed';
export const IMPLANT_RETURNED = 'Returned';
export const IMPLANT_DISPOSED = 'Disposed';
export const CONSUMED = 'Consumed';

const normalize = (note) => (note != null ? String(note).trim().toLowerCase() : '');

export const isConsumedNote = (note) => normalize(note) === 'consumed';

export const isReturnNote = (note) => {
  const n = normalize(note);
  return n === 'returned' || n === 'material returned';
};

export const isDisposedNote = (note) => {
  const n = normalize(note);
  return n === 'disposed' || n === 'material disposed';
};

export const hasExpiry = (batch) => Boolean(batch?.expiry_date);

export const materialNoteForAction = (action) => {
  if (action === 'returned') return MATERIAL_RETURNED;
  if (action === 'disposed') return MATERIAL_DISPOSED;
  return CONSUMED;
};

export const implantNoteForAction = (action) => {
  if (action === 'returned') return IMPLANT_RETURNED;
  if (action === 'disposed') return IMPLANT_DISPOSED;
  return CONSUMED;
};
